package data.models

import kotlinx.serialization.Serializable

@Serializable
data class ChangePasswordData(
    val currentPassword: String,
    val newPassword: String,
)


